import React, { useEffect, useState, useRef } from 'react';
import { MDBSelect, MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBSpinner } from 'mdb-react-ui-kit';
import axios from 'axios';

const Chapters = ({ chaptersCount, setChaptersCount, selectedChapters, setSelectedChapters, setOffset, sessionId }) => {
    const [options, setOptions] = useState([]);
    const [collapse, setCollapse] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const abortControllerRef = useRef(null);

    const setChaptersForLawsArchive = ({chaptersCount}) => {
        if (chaptersCount) setIsLoading(false);
        else return;
        const chapters = Object.keys(chaptersCount);
        const mappedSubjects = chapters.map(item => ({
            value: item,
            text: item
        }));
        const removedDuplicatedSubjects = removeDuplicatesByCode(mappedSubjects);
        const options = [...removedDuplicatedSubjects];
        setOptions(options);
    }

    const setChaptersForLaws = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/bills/search?sort=sessionLawChapterNumber,desc&limit=1`,
                {
                    sessionIds: [sessionId]
                }
            );

            if (response.data && response.data.content && response.data.content.length > 0) {
                const maxChapter = response.data.content[0].sessionLawChapterNumber;
                const options = Array.from({length: maxChapter}, (_, i) => ({
                    value: i + 1,
                    text: `${i + 1}`
                }));
                setOptions(options);
            } else {
                setOptions([{value: 0, text: "No Chapters Available"}]);
            }
        } catch (error) {
            console.error('Error fetching chapters:', error);
            setOptions([{value: 0, text: "Error Loading Chapters"}]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // Cancel any ongoing requests
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        // Create a new AbortController
        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;

        const fetchChapters = async () => {
            setIsLoading(true);
            try {
                if(sessionId < 1000) {
                    await setChaptersForLaws();
                } else {
                    setChaptersForLawsArchive({chaptersCount});
                }
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    console.error('Error fetching chapters: ', error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchChapters();

        // Cleanup function
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [chaptersCount, sessionId]);

    const removeDuplicatesByCode = (subjects) => {
        const uniqueCodes = new Set();
        return subjects.filter(item => !uniqueCodes.has(item.value) && uniqueCodes.add(item.value));
    };

    const handleChapterSelection = (value) => {
        if (!value || (Array.isArray(value) && value.length === 0)) {
            setSelectedChapters([]);
        } else {
            // Handle both single and multiple selections
            const chapters = Array.isArray(value) 
                ? value.map(item => Number(item.value))
                : [Number(value.value)];
            setSelectedChapters(chapters);
        }
        setOffset(0);
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink className='accordion-button' icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Chapters
            </MDBSideNavLink>
            <MDBSideNavCollapse show={collapse}>
                {
                    isLoading ?
                        <span className='m-4'><MDBSpinner size='sm' role='status' tag='span' className='me-2' /> Loading...</span>
                        :
                        <li className="p-3">
                            <MDBSelect
                                multiple
                                data={options}
                                label="-- Select Chapters --"
                                id="chapterFilter"
                                search
                                clearBtn
                                selected={selectedChapters}
                                onValueChange={handleChapterSelection}
                                value={selectedChapters}
                            />
                        </li>
                }
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default Chapters;